import { HttpClient, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'; //TO DO: replace by CSS + animate.enter/leave strategy for anmiations
import { provideRouter, RedirectCommand, Router, withComponentInputBinding, withNavigationErrorHandler } from '@angular/router';
import { HttpLoaderFactory } from '@common/translation-loader.factory';
import { FormlyModule } from '@ngx-formly/core';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { NgWizardConfig, NgWizardModule, THEME } from 'ng-wizard';

import { authInterceptor } from '@app/http-interceptors/auth-interceptor';
import { errorInterceptor } from '@app/http-interceptors/error.interceptor';
import { httpInterceptorProviders } from '@app/http-interceptors/index';
import { noopInterceptorProvider } from '@app/http-interceptors/noop-interceptor';
import { spinnerInterceptor } from '@app/http-interceptors/spinner.interceptor';
import { translationInterceptor } from '@app/http-interceptors/translation.interceptor';
import { environment } from '@environments/environment';
import { IDENTITY_API_URL_TOKEN } from '@identity/identity-url-token';
import { SharedProvider } from '@shared/shared.provider';
import { APP_VERSION_TOKEN } from './app.version';
//import { errorInterceptor } from './interceptors/error.interceptor';
import { appInitializer } from '@app/app-initializer';
import { AuthService } from '@app/auth.service';
import { MessageService } from '@common/message.service';
import { MyMissingTranslationHandler } from '@common/missing-translation.handler';
import { TOAST_CONFIG } from '@common/toast-configuration';
import { SasDynamicFormsTypes } from '@shared/sas-dynamic-form/sas-dynamic-forms-types.service';
import { SearchDataService } from '@shared/services/search-data.service';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

const IDENTITY_URL = environment.identityAPI;
const VERSION_VALUE = 'terraquest_v0.1';

const ngWizardConfig: NgWizardConfig = {
    theme: THEME.dots,
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideAppInitializer(appInitializer),
        importProvidersFrom(
            FormlyModule.forRoot({ types: SasDynamicFormsTypes }),
            NgWizardModule.forRoot(ngWizardConfig)
        ),
        provideHttpClient(
            withFetch(),
            withInterceptorsFromDi(),
            withInterceptors([spinnerInterceptor, authInterceptor, translationInterceptor, errorInterceptor])
        ),
        noopInterceptorProvider,
        httpInterceptorProviders,
        { provide: IDENTITY_API_URL_TOKEN, useValue: IDENTITY_URL },
        { provide: APP_VERSION_TOKEN, useValue: VERSION_VALUE },
        MessageService,
        AuthService,
        provideRouter([], withComponentInputBinding(), withNavigationErrorHandler((error: any) => {
            console.error('Navigation error:', error);
            const router = inject(Router);
            const urlTree = router.createUrlTree(['/error']);
            return new RedirectCommand(urlTree);
        })),
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: MyMissingTranslationHandler
                }
            })
        ),
        provideHotToastConfig(TOAST_CONFIG),
        provideCharts(withDefaultRegisterables()),
        SharedProvider,
        provideAnimationsAsync(),
        SearchDataService
    ]
};
